'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileName = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _fileUploadGetters = require('./fileUploadGetters');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFileName = exports.getFileName = function getFileName(attachment) {
  var file = (0, _fileUploadGetters.getFile)(attachment);

  return (0, _get2.default)('name', file) || '';
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-schema/static-1.4266/js/file-upload/operators/getFileName.js
// module id = 1162
// module chunks = 2 3